/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const TableNotVerified: React.FC<Props> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.3813 1C18.2751 1 18.9994 1.72446 18.9995 2.61816V17.3809C18.9994 18.2746 18.2751 18.999 17.3813 18.999H10.0249C10.0184 18.9992 10.0119 19 10.0054 19C9.999 19 9.99217 18.9992 9.98584 18.999H2.61865C1.72504 18.9989 1.00058 18.2745 1.00049 17.3809V2.61816C1.00061 1.72456 1.72506 1.00017 2.61865 1H17.3813ZM2.50049 10.7598V17.3809C2.50058 17.4461 2.55346 17.4989 2.61865 17.499H9.25537V10.7598H2.50049ZM10.7554 10.7598V17.499H17.3813C17.4467 17.499 17.4994 17.4462 17.4995 17.3809V10.7598H10.7554ZM2.61865 2.5C2.55348 2.50017 2.50061 2.55299 2.50049 2.61816V9.25977H9.25537V2.5H2.61865ZM10.7554 9.25977H17.4995V2.61816C17.4994 2.55288 17.4467 2.5 17.3813 2.5H10.7554V9.25977Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default TableNotVerified;
